import type { DefaultComponentType } from '../../../../src/utils/types';
import './CharCount.pcss';

export type CharCountProps = DefaultComponentType & {
    elementSelector: string;
    maxlength?: number;
    disabled?: boolean;
    currentLength?: number;
};

export default class CharCount extends HTMLElement {
    readonly #elementToCount: HTMLInputElement | HTMLTextAreaElement | null | undefined;

    #currentLength = 0;

    #minimumCharElement = this.querySelector('[data-name="min-char-length"]') as HTMLElement;

    constructor(props?: CharCountProps) {
        super();

        const elementSelector = props?.elementSelector ?? this.dataset.elementSelector;

        if (!elementSelector) {
            // eslint-disable-next-line no-console
            console.warn(`CharCount: elementSelector not specified.`);
            return;
        }

        this.#elementToCount = <HTMLInputElement | HTMLTextAreaElement>(
            this.parentElement?.querySelector(elementSelector)
        );

        if (!this.#elementToCount) {
            // eslint-disable-next-line no-console
            console.warn(`CharCount: elementToCount not found`);
        }
    }

    protected connectedCallback(): void {
        this.#calculateLength();
        this.#elementToCount?.addEventListener('input', this.#calculateLength.bind(this));
    }

    protected disconnectedCallback(): void {
        this.#elementToCount?.removeEventListener('input', this.#calculateLength.bind(this));
    }

    #calculateLength(): void {
        this.#currentLength = this.#elementToCount?.value.length || 0;
        this.#update();
    }

    #update(): void {
        this.#minimumCharElement.innerHTML = this.#currentLength.toString();
    }
}

if (!window.customElements.get('nh-char-count')) {
    window.customElements.define('nh-char-count', CharCount);
}
